import React, { useCallback, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import CellFactory from '../CellFactory/CellFactory'
import { numberFormat } from '../../../../utils/formats/formats'

const defaultValue = ''
const cellFormat = (type, value) => {
  if (['number', 'currency'].includes(type)) {
    return numberFormat(value, type)
  }
  return value
}
const cardTypes = {
  NO: 'Nominativa',
  NN: 'No nominativa',
}
const textFormat = (value, id, original, type) => {
  if (type === 'boolean') {
    return value ? 'Si' : 'No'
  }
  if (type === 'inactiveStatus') {
    return value ? 'Activo' : 'Desvinculado'
  }
  if (id === 'info' && original?.Documento === null) {
    return null
  }
  if (id === 'sNombre') {
    const name = value ? value : ''
    const lastName = original.sApellidoPaterno ? original.sApellidoPaterno : ''
    const surname = original.sApellidoMaterno ? original.sApellidoMaterno : ''
    return `${String(name).toUpperCase()} ${String(
      lastName,
    ).toUpperCase()} ${String(surname).toUpperCase()}`
  }
  if (id === 'sSoloNombre') {
    const surname = original.sNombre
    return `${String(surname).toUpperCase()}`
  }
  if (id === 'sApellidos') {
    const lastName = original.sApellidoPaterno ? original.sApellidoPaterno : ''
    const surname = original.sApellidoMaterno ? original.sApellidoMaterno : ''
    return `${String(lastName).toUpperCase()} ${String(surname).toUpperCase()}`
  }
  if (id === 'info') {
    return 'Ver'
  }
  if (id === 'seeInfo') {
    return 'Ver Información'
  }
  if (id === 'deleteRefill') {
    return 'ELIMINAR'
  }
  if (id === 'sTipoTarjeta') {
    return value ? cardTypes[value] : value
  }
  if (id === 'sTipoAsignacion') {
    if (value === 'AS') {
      return original?.bRecargaAutomatica ? 'Recarga (Automática)' : 'Recarga'
    }
    return 'Descuento'
  }
  if (['CentroCosto', 'Sucursal'].includes(id)) {
    return !value ? 'Sin asignar' : value
  }
  if (id === 'bPrePago') {
    return value ? 'Pendiente' : ''
  }
  return value
}

function CustomCell({
  value: initialValue,
  row: { index, original },
  column: { type, id, editable, keyValue },
  updateMyData,
  textVariant = null,
  onEmployeeClick = () => null,
  onRefillStatusClick,
  onDeclineRefill,
}) {
  const [value, setValue] = useState(
    initialValue || initialValue === 0
      ? cellFormat(type, initialValue)
      : defaultValue,
  )

  const [sendData, setSendData] = useState(false)
  const handleSendData = useCallback((hasSend) => {
    setSendData(hasSend)
  }, [])
  const onChange = useCallback((event) => {
    setValue(event.target.value)
  }, [])

  useEffect(() => {
    if (sendData) {
      if (editable && value !== initialValue) {
        updateMyData(index, {
          ...original,
          nMonto: cellFormat(type, value),
          sComentario: '',
        })
      }
      handleSendData(false)
    }
  }, [value, editable, initialValue, sendData, handleSendData])

  useEffect(() => {
    setValue(cellFormat(type, original[id]))
  }, [original, type, id])

  const clickValue = useMemo(() => {
    if (type === 'clickeable') {
      if (initialValue) {
        return initialValue
      }
      if (keyValue) {
        return original[keyValue]
      }
      return original.sEmpleado
    }
    if (type === 'fill_balance') {
      return original
    }
    if (type === 'deleteRefill') {
      return original?.nAsignacion
    }
  }, [original, initialValue, type])

  const onClick = useCallback(() => {
    if (type === 'refillStatus') {
      onRefillStatusClick(original)
    }
    if (id === 'deleteRefill') {
      onDeclineRefill(original.nAsignacion)
    }
    if (type === 'clickeable') {
      onEmployeeClick(clickValue)
    } else if (type === 'fill_balance') {
      updateMyData(index, {
        ...original,
        nMonto: cellFormat('currency', original.sSaldo),
      })
      onEmployeeClick({ data: original, index })
    }
  }, [type, original, updateMyData, onEmployeeClick, index])
  return (
    <CellFactory
      type={type}
      editable={editable}
      componentProps={{
        textVariant: textVariant,
        value: textFormat(value, id, original, type),
        onChange,
        onBlur: handleSendData,
        onFocus: handleSendData,
        onClick: onClick,
        clickValue,
        data: { original },
      }}
    />
  )
}

CustomCell.propTypes = {
  column: PropTypes.object,
  onDeclineRefill: PropTypes.func,
  onEmployeeClick: PropTypes.func,
  onRefillStatusClick: PropTypes.func,
  row: PropTypes.object,
  textVariant: PropTypes.string,
  updateMyData: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
}

export default CustomCell
